import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../store'; 
import { useAppDispatch } from '../reduxhooks';
import { loadAllIframeVariablesFromLocalStorage } from '../redux/CartRedux';
import { restartLoginStatus } from '../redux/AccountRedux';

// CHILD COMPONENT
export const IframeMessageBridge = () => {
    const dispatch = useAppDispatch();

    const userSub = useSelector((state: RootState) => state.account.sub);
    const isFirstRunAccountLoad = useRef(true);

    // Watch the Cart Hash to detect internal changes
    const cartHash = useSelector((state: RootState) => state.cart.cartProductListHash);
    const isFirstRun = useRef(true);

    // 1. INCOMING SIGNALS (INCOMING TO CHILD)
    useEffect(() => {
        const handleParentMessage = (event: MessageEvent) => {
            if (!event.data || typeof event.data !== 'object') return;

            const { type } = event.data;

            // Sync Cart
            if (type === "SYNC_CART_FROM_PARENT") {
                dispatch(loadAllIframeVariablesFromLocalStorage());
            }
            if (type === "RELOAD_ACCOUNT_CHILD") {
                dispatch(restartLoginStatus());
            }
        };

        window.addEventListener("message", handleParentMessage);

        return () => window.removeEventListener("message", handleParentMessage);
    }, [dispatch]);

    // 2. OUTGOING SIGNALS (OUTGOING FROM CHILD)
    useEffect(() => {
        if (isFirstRun.current) {
            isFirstRun.current = false;
            return;
        }

        // Debounce slightly to ensure LocalStorage write completes before Parent reads
        const timeoutId = setTimeout(() => {
            console.log("Child: Cart changed. Signaling Parent...");
            window.parent.postMessage({ type: "SYNC_CART_FROM_CHILD" }, "*");
        }, 50);

        return () => clearTimeout(timeoutId);
    }, [cartHash]);

    useEffect(() => {
        if (isFirstRunAccountLoad.current) {
            isFirstRunAccountLoad.current = false;
            return;
        }

        // Debounce slightly to ensure LocalStorage write completes before Parent reads
        const timeoutId = setTimeout(() => {
            console.log("Child: User changed. Signaling Parent...");
            window.parent.postMessage({ type: "RELOAD_ACCOUNT_PARENT" }, "*");
        }, 50);

        return () => clearTimeout(timeoutId);
    }, [userSub]);

    return null;
};